import React, { ReactNode, useEffect, useRef } from "react";
import cn from "classnames";
import styled from "styled-components";

interface ITabPanelProps {
  children: ReactNode;
  type?: string;
}

const TabPanel = (props: ITabPanelProps) => {
  const TabBoxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.type === "scroll" && props.children) {
      TabBoxRef.current?.scrollTo(0, 0);
    }
  }, [props.children]);

  return (
    <TabPanelSet className={cn({ scrollBox: props.type === "scroll" })} ref={TabBoxRef}>
      {props.children}
    </TabPanelSet>
  );
};

const TabPanelSet = styled.div`
  padding-top: 15px;
  &.scrollBox {
    overflow: hidden;
    overflow-x: scroll;
    margin-right: -15px;
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "stretch", "nowrap")}
    > div {
      margin-top: 0;
      margin-right: 5px;
      &:last-child {
        margin-right: 15px;
      }
    }
  }
`;

export default TabPanel;
